import React, { useCallback } from 'react';

const StoreInfo = ({ store_info }) => {
  const dateTime = new Date().getTime();
  const handleOpenExternalbrowser = useCallback((e) => {
    const param = { "method": "GET", "url": store_info.url };
    try {
      window.MobilePaymentBridge.openExternalBrowser(JSON.stringify(param));
    } catch (error) {
      alert(error)
    }
  });
  return (
    <div className="store_area">
      <div className="store_title">
        <span className="store_logo">
          <img
            src={'./img/bi_' + store_info.id + '.png?dateTime='+ dateTime}
            width="72"
            height="72"
            alt="가맹점로고"
          />
        </span>
        <span>{store_info.category}</span>
        <strong>{store_info.name}</strong>
        <a onClick={handleOpenExternalbrowser}>{store_info.url}</a>
      </div>
      <div className="store_info">
        {store_info.description.map((desc, index) => (
          <p key={index}>{desc}</p>
        ))}
      </div>
    </div>
  );
};

export default StoreInfo;
